<script>
  import { writable } from "svelte/store";
  import { crossfade, fade } from "svelte/transition";
  import Login from "./login.svelte";
  import { user } from "@/meteor";
  import Snack from "@/components/Snack.svelte";
  import { currentOrder } from "@/stores";

  import Navbar from "@/components/Navbar.svelte";
  export let routes, route, scoped, url;


  const [send, receive] = crossfade({ duration: 500 });

  const searchText = writable("");

  const statusOptionsObj = {
    pending: "afventer",
    processing: "behandler",
    finished: "afsluttet",
    cancelled: "annulleret",
    refunded: "refunderet"
  };

  const statusOptions = Object.entries(statusOptionsObj).map(
    ([value, name]) => ({ value, name })
  );

  $: $searchText && history.pushState({}, "", "/products");
  $: if (!$user) {
    history.pushState({}, "", "/login");
  }

  $: loggedIn = !!$user;
</script>

{#if loggedIn}
  <Navbar {user} {url} {route} currentOrder={$currentOrder} installPrompt={scoped.installPrompt} >
    <slot scoped={{ searchText, send, receive, currentOrder: $currentOrder, statusOptionsObj, statusOptions }} />
  </Navbar>
{:else}
  <Login {send} {receive} />
{/if}

<Snack />
